export const emptyFormValue = '-'

export const showFormValue = (value: string | number): string | number => {
  return value === '' ? emptyFormValue : value
}
